import Model from './base';

export class CompanyOwnership extends Model {
  resource() {
    return 'user/companyownership';
  }

  defaultAttributes() {
    return {
      short_name_ci: null,
      sort_order: null,
      kpp_required: false,
      company_ownership_translations: [],
    }
  }
}
